import React, {Component} from 'react';
import {connect, Field} from 'formik';
import {parsers} from '@neosvoc/nv-platform-core-common';
import CustomRadio from './CustomRadio';
import {findIndex, get} from 'lodash';
import Error from '../Error';
import classNames from 'classnames';

class MultipleChoiceType extends Component {
    constructor(props) {
        super(props);
        this.validate = this.validate.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleChangeExclusive = this.handleChangeExclusive.bind(this);
        this.validateDetail = this.validateDetail.bind(this);
    }

    componentDidMount() {
        this.props.formik.registerField(this.props.id, this);
    }

    componentWillUnmount() {
        this.props.formik.unregisterField(this.props.id);
    }

    componentDidUpdate(prevProps) {
        if (this.props.id !== prevProps.id) {
            this.props.formik.unregisterField(prevProps.id);
            this.props.formik.registerField(this.props.id, this);
        }
    }

    validate(value) {
        try {
            parsers.multipleChoice(value, this.props);
        } catch (err) {
            return err.payload;
        }
    }

    validateDetail(value) {
        try {
            parsers.string(value, {required: true});
        } catch (err) {
            return err.payload;
        }
    }

    handleChange(e) {
        const {formik, id, value, choices} = this.props;
        const checkedValue = e.target.value;
        let newValue = value.slice();
        const index = newValue.indexOf(checkedValue);
        if (index >= 0) {
            newValue.splice(index, 1);
        } else {
            newValue.push(checkedValue);
        }
        const exclusiveIds = choices.filter((c) => c.exclusive).map((c) => c.id);
        newValue = newValue.filter((v) => !exclusiveIds.includes(v));
        formik.setFieldValue(id, newValue);
        this.updatePreviousComponent(newValue);
    }

    handleChangeExclusive(e) {
        const checkedValue = e.target.value;
        const {formik, id} = this.props;
        const newValue = [checkedValue];
        formik.setFieldValue(id, newValue);
        this.updatePreviousComponent(newValue);
    }

    getPreviousReference(index) {
        const {id, choices, previousContent} = this.props;
        if (previousContent && previousContent.type === 'staticImageGallery') {
            return `${id}_${choices[index].id}`;
        }
        return index;
    }

    updatePreviousComponent(newValue) {
        const {choices, previousContent} = this.props;

        if (previousContent && previousContent.type === 'staticImageGallery') {
            const allTargets = document.querySelectorAll('.singlechoice-img');
            for (const target of allTargets) {
                target.classList.remove('singlechoice-img-selected');
            }
            for (const checkedValue of newValue) {
                const targetIndex = findIndex(choices, {id: checkedValue});
                const targetElement = document.querySelector(`#singlechoice-img-${this.getPreviousReference(targetIndex)}`);
                targetElement.classList.add('singlechoice-img-selected');
            }
        }
    }

    render() {
        const {formik, choices, id, value, previousContent} = this.props;

        return (
            <div className={classNames({'mobile-hidden': previousContent.type === 'staticImageGallery'})}>
                {choices.map((choice, index) => (
                    choice.exclusive ?
                        <React.Fragment key={index}>
                            <CustomRadio key={`${index}_radio`} extraClass="custom-radio-exclusive" id={`multiplechoice-${id}_${choice.id}`} name={id}
                                value={choice.id} checked={value.includes(choice.id)} onChange={this.handleChangeExclusive}>{choice.value}</CustomRadio>
                            {choice.detail && value.includes(choice.id) &&
                                <div className={classNames('question', {error: get(formik.errors, `${id}_${choice.id}_detail`)})}>
                                    <Field key={`${index}_detail`} name={`${id}_${choice.id}_detail`} type="text" className="form-control"
                                        validate={this.validateDetail} />
                                    {get(formik.errors, `${id}_${choice.id}_detail`) ?
                                        <Error {...(get(formik.errors, `${id}_${choice.id}_detail`))} /> :
                                        null}
                                </div>
                            }

                        </React.Fragment> :
                        <div className="custom-control custom-checkbox" key={index}>
                            <input type="checkbox" className="custom-control-input" id={`multiplechoice-${id}_${choice.id}`} name={id}
                                value={choice.id} checked={value.includes(choice.id)} onChange={this.handleChange} />
                            <label className="custom-control-label" htmlFor={`multiplechoice-${id}_${choice.id}`}>{choice.value}</label>
                            {choice.detail && value.includes(choice.id) &&
                                <div className={classNames('question', {error: get(formik.errors, `${id}_${choice.id}_detail`)})}>
                                    <Field key={`${index}_detail`} name={`${id}_${choice.id}_detail`} type="text" className="form-control"
                                        validate={this.validateDetail} />
                                    {get(formik.errors, `${id}_${choice.id}_detail`) ?
                                        <Error {...(get(formik.errors, `${id}_${choice.id}_detail`))} /> :
                                        null}
                                </div>
                            }
                        </div>
                ))}
            </div>
        );
    }
}

export default connect(MultipleChoiceType);
